<template>
  <div class="row wrapper border-bottom white-bg page-heading align-items-center">
    <div class="col-lg-3 d-flex align-items-center">
      <h2>{{$t("navigations.shells")}}</h2>
      <button
        v-if="!showShellLoading"
        class="badge-btn ms-3"
        :class="shellsPageLevel === 'program' ? 'badge-program' : (shellsPageLevel === 'report' ? 'badge-report' : 'badge-study')"
      >
        <span class="dot-wrap">
          <span class="badge-dot-pulse"></span>
          <span class="badge-dot"></span>
        </span>
        {{ shellsPageLevel === 'program' ? 'Program Level Shell' : (shellsPageLevel === 'report' ? 'Report Level Shell' : 'Study Level Shell') }}
      </button>
    </div>
    <div class="col-lg-9 d-flex justify-content-end mt-3 mt-lg-0">
      <div class="form-group mb-0 mr-2" >
        <select class="form-select" v-model="selectedHeadingId" @change="onHeadingChange()">
          <option value="">{{ $t("navigations.report headings") || 'Report Headings' }}</option>
          <option v-for="heading in HeadingList" :key="heading.Headingid" :value="heading.Headingid">
            {{ heading.Headingname }}
          </option>
        </select>
      </div>
      <div class="form-group mb-0 mr-2">
        <select class="form-select" v-model="selectedReportId" @change="onReportChange()">
          <option value="">{{ $t("navigations.all reports") || 'All Reports' }}</option>
          <option v-for="report in ReportList" :key="report.Reportid" :value="report.Reportid">
            {{ report.Reportname }}
          </option>
        </select>
      </div>
      <div class="form-group mb-0 mr-2">
        <select class="form-select" v-model="selectedProgramId" @change="onProgramChange()">
          <option value="">{{ $t("navigations.all programs") || 'All Programs' }}</option>
          <option v-for="program in ProgramList" :key="program.ProgramId" :value="program.ProgramId">
            {{ program.ProgramName }}
          </option>
        </select>
      </div>
      <div v-if="$route && $route.query && (Array.isArray($route.query.from) ? $route.query.from[0] : $route.query.from) === 'tocgenerate'" class="ml-2 d-flex align-items-center">
        <div class="position-relative align-self-center" aria-label="Close" tabindex="0">
          <i class="fa fa-times cursor-pointer" src="../../assets/img/create.png"
            width="17"
            height="17" @click="shellsClose()"></i>
          <div class="tool-tip mt-3">{{ $t("navigations.close") }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="wrapper wrapper-content">
    <div class="ibox-body">
      <div class="ibox-title style_2 d-flex justify-content-between">
        <h5>{{$t("navigations.shell list")}}</h5>
         <div class="position-relative align-self-center" aria-label="Create Shell" tabindex="0">
        <img
          v-if="!hasError && !showShellLoading"
          class="cursor-pointer"
          src="../../assets/img/create.png"
          width="17"
          height="17"
          alt="Create Shell"
          @click="CreateShell()"
        />
       <div class="tool-tip mt-2">{{ $t("navigations.create shell") }}</div>
       </div>
      </div>

      <div class="ibox-content">

        <!-- Loading -->
        <div class="text-center py-4" v-if="showShellLoading">
          <img src="../../assets/img/loading.gif" width="15" alt="Loading" />
          <div class="mt-2">{{ $t("navigations.Please wait while the shell list is being loaded") }}</div>
        </div>

        <!-- No shells -->
        <div v-else-if="hasError" class="">
          <button class="save_btn py-1 px-4 text-white" @click="importDefaultShell()">
           {{$t("navigations.import shell")}}
          </button>
        </div>

        <!-- Shell List Table -->
        <div class="table-responsive" v-else>
          <table class="table table-striped table-bordered dataTables">
            <thead>
              <tr>
                <th class="sort_block" @click="SortSelected('TemplateName')">
                  <div class="d-flex flex-row justify-content-between">
                   {{$t("navigations.shell name") }}
                    <span><i class="fa fa-long-arrow-up"></i><i class="fa fa-long-arrow-down"></i></span>
                  </div>
                </th>
                <th class="sort_block" @click="SortSelected('Version')">
                  <div class="d-flex flex-row justify-content-between">
                    {{$t("navigations.shell version") }}
                    <span><i class="fa fa-long-arrow-up"></i><i class="fa fa-long-arrow-down"></i></span>
                  </div>
                </th>
                 <th class="sort_block" @click="SortSelected('IsDefault')">
                  <div class="d-flex flex-row justify-content-between">
                    {{$t("navigations.default") }}
                    <span><i class="fa fa-long-arrow-up"></i><i class="fa fa-long-arrow-down"></i></span>
                  </div>
                </th>
                <th class="sort_block" @click="SortSelected('LastModifiedAt')">
                  <div class="d-flex flex-row justify-content-between">
                    {{$t("navigations.created shell date") }}
                    <span><i class="fa fa-long-arrow-up"></i><i class="fa fa-long-arrow-down"></i></span>
                  </div>
                </th>
                <th class="text-center">{{ $t("navigations.shell edit") }}</th>
                <th class="text-center">{{ $t("navigations.shell actions") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(shell, index) in ShellList" :key="shell._id">
                <td>{{ shell.TemplateName }}</td>
                <td>{{ shell.Version }}</td>
                <td>
                  <span v-if="shell.IsDefault" class="badge-default">Default</span>
                  <span v-else>—</span>
                </td>
                <!-- Pass whole shell object — filter() picks CreatedAt, falls back to LastModifiedAt -->
                <td>{{ filter(shell) }}</td>
                <td class="text-center">
                  <router-link
                    :to="{
                      path: `/shells/edit/${shell._id || shell.id}`,
                      query: {
                        ...(selectedReportId || getShellReportId(shell) ? { reportId: selectedReportId || getShellReportId(shell) } : {}),
                        ...(selectedProgramId || getShellProgramId(shell) ? { programId: selectedProgramId || getShellProgramId(shell) } : {}),
                        from: 'shells'
                      }
                    }"
                  >
                    <i class="fa fa-edit edit-delete"></i>
                  </router-link>
                </td>
                <td class="text-center">
                  <div
                    class="position-relative cursor-pointer d-inline-block"
                    @click.stop="toggleAction(index)"
                  >
                    <i class="fa fa-ellipsis-v"></i>
                    <div class="plan-side-popup" v-if="showActionPopup[index]" :style="{ top: popupY + 'px', left: popupX + 'px' }"
                    @click.stop>
                      <div v-if="!shell.IsDefault" @click="setAsDefault(shell._id)">{{ $t("navigations.set as default") }}</div>
                      <div @click.stop="previewShell(shell._id)">{{ $t("navigations.preview") }}</div>
                      <div @click.stop="deleteShell(shell._id)">{{ $t("navigations.delete") }}</div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Pagination -->
          <div class="row mx-0" v-if="totalPages > 1">
            <div class="col-lg-12 d-flex justify-content-lg-end px-0">
              <v-pagination
                v-model="currentPageNumber"
                :pages="totalPages"
                :range-size="0"
                active-color="#618bd7"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ShellModal
    v-if="showShellModal"
    :editingId="editingShellId"
    :nextVersionData="nextVersionData"
    :reportId="selectedReportId"
    :programId="selectedProgramId"
    @closeModal="closeShellModal"
  />
  <ShellPreview
    v-if="showShellPreview"
    :editingId="editingShellId"
    @closeModal="closeShell"
  />
</template>

<script src="./Shells.js"></script>

<style scoped>
@import "../../assets/style.css";
@import "../../assets/formpage.css";
.form-group { margin-bottom: 0 !important; }
.sort_block { cursor: pointer; align-items: center; }
.cursor-pointer { cursor: pointer; }
.position-relative { position: relative; }
.plan-side-popup {
  position:fixed;
  right: 0;
  top: 20px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: #fff;
  width: min(140px, 90vw);
  box-shadow: 3px 3px 6px rgba(160, 160, 160, 0.5);
  z-index: 200;
}
.plan-side-popup > div {
  cursor: pointer;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
}
.plan-side-popup > div:hover { background-color: #e4eaf9; }
.badge-default {
  background-color: #618bd7;
  color: #fff;
  padding: 0.2rem 0.6rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  display: inline-block;
}
.badge-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 3px 10px 3px 10px;
  background: #EEF2FF;
  border: 1.5px solid #C7D2FE;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  color: #0242f0;
  cursor: pointer;
  letter-spacing: 0.01em;
  transition: background 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.badge-btn:hover {
  background: #E0E7FF;
  border-color: #A5B4FC;
  box-shadow: 0 2px 10px rgba(99,102,241,0.15);
}

.badge-study {
  background: #E8F6FF;
  border-color: #BEE6FF;
  color: #034E7B;
}

.badge-report {
  background: #fdfcc8;
  border-color: #f6ff73;
  color: #9c9201;
}

.badge-program {
  background: #F0FFF4;
  border-color: #CFF8DD;
  color: #0B6B3A;
}

.badge-study .badge-dot { background: #034E7B; }
.badge-report .badge-dot { background: #9c9201; }
.badge-program .badge-dot { background: #0B6B3A; }

.dot-wrap {
  position: relative;
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.badge-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #045c77;
  position: relative;
  z-index: 1;
}

/* .badge-dot-pulse {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: 10px; height: 10px;
  border-radius: 50%;
  background: #4e4ce2;
  animation: pulse 2s ease-out infinite;
} */


</style>
